module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.datasets) ? _c('div', [_c('div', [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-toggle": "tooltip",
      "title": "Refresh"
    },
    on: {
      "click": _vm.refreshDatasets
    }
  }, [_vm._v("Refresh "), _c('span', {
    staticClass: "fa fa-refresh"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table export-table table-condensed",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._m(1), _vm._v(" "), _vm._l((_vm.datasets), function(item) {
    return _c('tr', [_c('td', [_vm._v("\n                                        " + _vm._s(item.dataSetId) + "\n                                    ")]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-sm btn-default",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.showDataSetInfo(item)
        }
      }
    }, [_vm._v("Info")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-sm btn-warning",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.deleteDatasetClick(item)
        }
      }
    }, [_vm._v("Delete")])])])
  })], 2)])])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('colgroup', [_c('col', {
    attrs: {
      "span": "1"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "15%"
    },
    attrs: {
      "span": "1"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Dataset")]), _vm._v(" "), _c('th', [_vm._v("Options")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-67675c36", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67675c36"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/dashboard-datasets-dialog/dashboard-datasets-dialog.vue.html
// module id = 1111
// module chunks = 0